import React from 'react';
import { motion } from 'framer-motion';


const Button3 = ({ children, onClick, width }) => {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className="px-2 pl-5 py-2 flex items-center justify-center text-jbsBlue font-bold rounded-full"
      style={{
        width: width || 'auto',
        background: 'white',
        borderRadius: '50px',
      }}
    >
      <span className="mr-3 text-center">{children}</span>
    </motion.button>
  );
};

export default Button3;
